module.exports = __webpack_public_path__ + "66143bf2d5.woff2";